export const routes = {
    "/:taskId/oldPhysiotherapyAssessmentConsultation/*": {
        title: "Physiotherapy Assessment Consultation"
    },
    "/:taskId/physiotherapyAssessmentConsultation": {
        title: "Physiotherapy Assessment Consultation"
    },
};
